<template>
  <div>
    <v-nav></v-nav>
    <div style="margin-top: 2vh;width: 80%;margin-left: 10%;font-size: 24px;font-weight: bold;text-align: center">
        <div style="display: inline-block">Total visits: {{ totalVisit }}</div>
      <Icon type="md-contrast" style="display: inline-block;margin: 20px 20px"/>
        <div style="display: inline-block;">Total download: {{ totalDownload }}</div>
    </div>
    <div style="width: 100%;text-align: center;">
      <div id="visitMap" style="width: 80%;height: 80vh;z-index: 9999;display: inline-block"></div>
    </div>
  </div>
</template>

<script>
import "echarts/extension/bmap/bmap";
import VNav from "../public/v-nav";

export default {
  name: "visit",
  components: {VNav},
  data: function () {
    return {
      mapList: [],
      totalVisit : 0,
      totalDownload : 0
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      var that = this;
      this.$axios.post("/map/getData", {}).then(function (res) {
        that.mapList = res.data.mapList;
        that.totalVisit = res.data.totalVisit;
        that.totalDownload = res.data.totalDownload;
        that.drawMap();
      })
    },
    getBaseLog(x, y) {
      return Math.log(y) / Math.log(x);
    },
    drawMap() {
      // var that = this;
      var option = {
        title: {
          // text: 'Visits and download statistics',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: [90.97, 29.71],
          zoom: 1,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: 'water',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'land',
                elementType: 'all',
                stylers: {
                  color: '#f3f3f3'
                }
              },
              {
                featureType: 'railway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'highway',
                elementType: 'all',
                stylers: {
                  color: '#fdfdfd'
                }
              },
              {
                featureType: 'highway',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'poi',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'green',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'subway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'manmade',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'local',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'boundary',
                elementType: 'all',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'building',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'label',
                elementType: 'labels.text.fill',
                stylers: {
                  color: '#999999'
                }
              }
            ]
          }
        },
        series: [
          {
            name : "Visits and download",
            type: 'effectScatter',
            coordinateSystem: 'bmap',
            data: this.mapList,
            symbolSize: function (val) {
              return Math.log((parseFloat(val[2]) + parseFloat(val[3])) * 100) * 2;
            },
            encode: {
              tooltip : [2, 3],
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              formatter: '{b} : Visits:{@[2]}  Download:{@[3]}',
              position: 'right',
              show: false
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#333'
            },
            emphasis: {
              scale: true,
              label: {
                show: true
              }
            },
          },
        ]
      };
      var visitMap = this.$echarts.init(document.getElementById('visitMap'));
      visitMap.setOption(option);
      window.onresize = function () {
        this.initPage();
      }
    }
  }
}
</script>

<style scoped>
.BMap_cpyCtrl {

  display: none !important;

}

.anchorBL {

  display: none !important;

}
</style>